module.exports = __webpack_public_path__ + "img/existing-document-template.9ffde439.png";